import React, { useEffect, useState } from 'react';
import { Box, Flex, HStack, VStack, Text, Circle } from '@chakra-ui/react';
import BottomNavBar from '../../../BottomNavBar';
import { AccountContext } from '../../../AccountContext';
import { useContext } from 'react';
import ModalEmpreendedor from './ModalEmpreendedor';
import Loading from 'components/Loading';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import ModalProvaDeVida from './ModalProvaDeVida';
import useRecebedor from '../../../../hooks/useRecebedor';
import ModalAvisoCadastroDadosBancarios from './ModalAvisoCadastroDadosBancarios';
import usePredefinedToastNotify from 'hooks/usePredefinedToastNotify';
import { GoAlertFill, GoClock } from 'react-icons/go';
import { FiBell, FiArrowDownLeft, FiTrendingUp, FiArrowRight, FiInfo, FiChevronRight, FiCheck, FiUserPlus } from 'react-icons/fi';
import { BsReceipt, BsBook, BsBank, BsCrosshair, BsHourglass } from 'react-icons/bs';
import { MdOutlineAttachMoney, MdOutlineConfirmationNumber } from 'react-icons/md';
import { api } from 'api/api';
import ChildHeader from '../ChildHeader';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useViewModel = () => {
  const { user, setPage, setUser } = useContext(AccountContext);
  setPage('Revendedor');

  const [contratos, setContratos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salesTicket, setSalesTicket] = useState(null);
  const [atividade, setAtividade] = useState([]);

  const notify = usePredefinedToastNotify();
  const navigate = useNavigate();
  const recebedor = useRecebedor(user?.recipient_id, user.username || user.cpf);

  const fetchContratos = async () => {
    const username = user.username || user.cpf;
    const url = `${ENDPOINT}/entrepreneur/extrato/contratos/${user.id_vendedor}?username=${encodeURIComponent(username)}`;
    const response = await api(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const fetchData = await response.json();
    setUser((prev) => ({ ...prev, contratosEmpreendedor: fetchData.data.contratos }));
    setContratos(fetchData.data.contratos);
  };

  const fetchEmpresas = async () => {
    const username = user.username || user.cpf;
    const url = `${ENDPOINT}/entrepreneur/extrato/credenciados/${user.id_vendedor}?username=${encodeURIComponent(username)}`;
    const response = await api(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const fetchData = await response.json();
    setUser((prev) => ({ ...prev, empresasEmpreendedor: fetchData.data }));
    setEmpresas(fetchData.data);
  };

  const fetchVendedores = async () => {
    const username = user.username || user.cpf;
    const url = `${ENDPOINT}/entrepreneur/extrato/vendedores/${user.id_vendedor}?username=${encodeURIComponent(username)}`;
    const response = await api(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const fetchData = await response.json();
    setUser((prev) => ({ ...prev, vendedoresEmpreendedor: fetchData.data.result }));
    setVendedores(fetchData.data.result);
  };

  const fetchSalesTicket = async () => {
    if (!user.id_vendedor) return;
    try {
      await api(`${ENDPOINT}/entrepreneur/sales`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vendedor_id: user.id_vendedor, username: user.username || user.cpf }),
      }).then(async (res) => {
        console.log('fetchSalesTicket response', res);
        const data = await res.json();
        if (data?.success) setSalesTicket(data.data);
      });
    } catch (e) {
      console.log('fetchSalesTicket error:', e);
    }
  };

  async function fetchDatas() {
    if (user.contratosEmpreendedor?.length > 0) {
      setContratos(user.contratosEmpreendedor);
    } else {
      await fetchContratos();
    }
    if (user.empresasEmpreendedor?.length > 0) {
      setEmpresas(user.empresasEmpreendedor);
    } else {
      await fetchEmpresas();
    }
    if (user.vendedoresEmpreendedor?.length > 0) {
      setVendedores(user.vendedoresEmpreendedor);
    } else {
      await fetchVendedores();
    }
    setLoading(false);
  }

  const handlerOnPressGerarQrCode = () => navigate('/empreendedor/qrcode');

  const openChatSuporteWhatsapp = (msg = '') => {
    window.open(`https://wa.me/558002802133?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const handlePreencherDadosBancarios = () => navigate('/empreendedor/dados-bancarios');

  useEffect(() => {
    fetchDatas();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const fetchAtividade = async () => {
    try {
      const res = await api(`${ENDPOINT}/entrepreneur/atividade`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vendedor_id: user.id_vendedor, username: user.username || user.cpf }),
      });
      const data = await res.json();
      console.log('fetchAtividade response', data.data);
      if (data?.success) setAtividade(data.data);
    } catch (e) {
      console.log('fetchAtividade error:', e);
    }
  };

  async function fetchRecebedor() {
    const res = await api(`${ENDPOINT}/entrepreneur/atualizar_recebedor`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: user.username || user.cpf }),
    });
    const data = await res.json();
    if (data?.success) setUser(...(prev) => ({ ...prev, recipient_id: data.recipient_id_vindi }));
  }

  useEffect(() => {
    fetchRecebedor();
    fetchSalesTicket();
    fetchAtividade();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    notify,
    user,
    contratos,
    empresas,
    vendedores,
    loading,
    salesTicket,
    atividade,
    recebedor,
    handlerOnPressGerarQrCode,
    openChatSuporteWhatsapp,
    handlePreencherDadosBancarios,
    navigate,
  };
};

function formatBRL(value) {
  if (value == null) return '...';
  return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const diffH = Math.floor((Date.now() - date) / 3600000);
  const diffD = Math.floor(diffH / 24);
  if (diffH < 1) return 'agora';
  if (diffH < 24) return `${diffH}h`;
  if (diffD === 1) return 'Ontem';
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

function BalanceCard({ salesTicket, navigate }) {
  const mesAtual = new Date().toLocaleString('pt-BR', { month: 'long' });
  return (
    <Box bgGradient="linear(135deg, #2BA89E, #1F7D75)" borderRadius="20px" p="18px" w="100%">
      <Flex justifyContent="space-between" alignItems="center">
        <HStack spacing="8px">
          <FiArrowDownLeft color="rgba(255,255,255,0.8)" size={16} />
          <Text color="rgba(255,255,255,0.8)" fontSize="13px" fontWeight="500">
            Recebido em {mesAtual}
          </Text>
        </HStack>
      </Flex>

      <HStack spacing="6px" alignItems="flex-end" mt="8px">
        <Text color="rgba(255,255,255,0.8)" fontSize="16px" fontWeight="600" mb="2px">
          R$
        </Text>
        <Text color="white" fontSize="30px" fontWeight="700" lineHeight="1">
          {formatBRL(salesTicket?.valor_total)}
        </Text>
      </HStack>

      <Box h="1px" bg="rgba(255,255,255,0.15)" my="14px" />

      <Flex justifyContent="space-between" alignItems="center">
        <HStack spacing="10px">
          <Flex bg="rgba(255,255,255,0.15)" borderRadius="10px" w="36px" h="36px" alignItems="center" justifyContent="center">
            <BsHourglass color="white" size={18} />
          </Flex>
          <VStack spacing="1" alignItems="flex-start">
            <Text color="rgba(255,255,255,0.8)" fontSize="11px" fontWeight="500">
              A receber
            </Text>
            <Text color="white" fontSize="15px" fontWeight="700">
              R$ {formatBRL(salesTicket?.previsto_receber)}
            </Text>
          </VStack>
        </HStack>

        <Box as="button" bg="white" borderRadius="12px" px="14px" py="10px" onClick={() => navigate('/empreendedor/extrato')}>
          <HStack spacing="6px">
            <Text color="#1F7D75" fontSize="13px" fontWeight="600">
              Ver extrato
            </Text>
            <FiArrowRight color="#1F7D75" size={14} />
          </HStack>
        </Box>
      </Flex>

      <HStack spacing="6px" mt="10px">
        <FiInfo color="rgba(255,255,255,0.8)" size={12} />
        <Text color="rgba(255,255,255,0.8)" fontSize="10px" fontWeight="500">
          Transferido conforme compensação (Pix, boleto ou cartão)
        </Text>
      </HStack>
    </Box>
  );
}

function formatCompact(value) {
  if (value == null) return '...';
  const n = Number(value);
  if (n >= 1000) return `R$ ${(n / 1000).toFixed(1).replace('.', ',')}k`;
  return `R$ ${n.toFixed(2).replace('.', ',')}`;
}

function KpiRow({ salesTicket }) {
  const kpis = [
    {
      icon: <MdOutlineConfirmationNumber color="#1F7D75" size={17} />,
      iconBg: '#E8F5F3',
      value: formatCompact(salesTicket?.ticket_medio),
      label: 'Ticket médio',
    },
    {
      icon: <MdOutlineAttachMoney color="#F97316" size={17} />,
      iconBg: '#FEEEDF',
      value: formatCompact(salesTicket?.valor_total),
      label: 'Vendas do mês',
    },
    {
      icon: <BsCrosshair color="#8B5CF6" size={15} />,
      iconBg: '#EFEAFD',
      value: salesTicket ? `${salesTicket.taxa_de_conversao}%` : '...',
      label: 'Conversão',
    },
  ];

  return (
    <HStack spacing="10px" w="100%" alignItems="stretch">
      {kpis.map((kpi, i) => (
        <Box key={i} bg="white" borderRadius="16px" p="14px" border="1px solid #EEF1F5" flex={1}>
          <Flex mb="6px">
            <Flex bg={kpi.iconBg} borderRadius="10px" w="32px" h="32px" alignItems="center" justifyContent="center">
              {kpi.icon}
            </Flex>
          </Flex>
          <Text color="#0F1B2A" fontSize="18px" fontWeight="700" lineHeight="1.1">
            {kpi.value}
          </Text>
          <Text color="#5B6B7A" fontSize="11px" fontWeight="500" mt="2px">
            {kpi.label}
          </Text>
        </Box>
      ))}
    </HStack>
  );
}

function QuickActions({ onPressGerarQrCode, navigate }) {
  const actions = [
    [
      /*{
        icon: <BsQrCode color="#1F7D75" size={22} />,
        iconBg: '#E8F5F3',
        title: 'QR Code',
        desc: 'Indicação rápida',
        onPress: onPressGerarQrCode,
      }, */
      {
        icon: <BsReceipt color="#F97316" size={22} />,
        iconBg: '#FEEEDF',
        title: 'Extrato',
        desc: 'Financeiro detalhado',
        onPress: () => navigate('/empreendedor/extrato'),
      },
    ],
    [
      {
        icon: <BsBook color="#3B82F6" size={22} />,
        iconBg: '#E4EEFE',
        title: 'Material',
        desc: 'Apoio para vendas',
        onPress: () => navigate('/emprendedor/materialapoio'),
      },
      {
        icon: <BsBank color="#8B5CF6" size={22} />,
        iconBg: '#EFEAFD',
        title: 'Dados bancários',
        desc: 'Recebimento',
        onPress: () => navigate('/empreendedor/dados-bancarios'),
      },
    ],
  ];

  return (
    <VStack spacing="14px" w="100%" alignItems="flex-start">
      <Flex justifyContent="space-between" alignItems="center" w="100%">
        <Text color="#0F1B2A" fontSize="17px" fontWeight="700">
          Acesso rápido
        </Text>
      </Flex>

      <VStack spacing="12px" w="100%">
        {actions.map((row, ri) => (
          <HStack key={ri} spacing="12px" w="100%" alignItems="stretch">
            {row.map((action, ai) => (
              <Box
                key={ai}
                as="button"
                bg="white"
                borderRadius="18px"
                p="16px"
                border="1px solid #EEF1F5"
                flex={1}
                h="130px"
                onClick={action.onPress}
                textAlign="left"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="flex-start"
                cursor="pointer"
                _active={{ opacity: 0.8 }}
              >
                <Flex bg={action.iconBg} borderRadius="12px" w="44px" h="44px" alignItems="center" justifyContent="center">
                  {action.icon}
                </Flex>
                <VStack spacing="2px" alignItems="flex-start" w="100%">
                  <Text color="#0F1B2A" fontSize="14px" fontWeight="700">
                    {action.title}
                  </Text>
                  <Text color="#5B6B7A" fontSize="11px" fontWeight="500">
                    {action.desc}
                  </Text>
                </VStack>
              </Box>
            ))}
          </HStack>
        ))}
      </VStack>
    </VStack>
  );
}

function AtividadeRecente({ atividade }) {
  const navigate = useNavigate();
  return (
    <VStack spacing="14px" w="100%" alignItems="flex-start">
      <Flex justifyContent="space-between" alignItems="center" w="100%">
        <Text color="#0F1B2A" fontSize="17px" fontWeight="700">
          Atividade recente
        </Text>
        <VStack style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <Text
            color="#1F7D75"
            fontSize="13px"
            fontWeight="600"
            onPress={() => {
              console.log('/empreendedor/contratos-vendidos');
              navigate('/empreendedor/contratos-vendidos');
            }}
            onClick={() => {
              console.log('/empreendedor/contratos-vendidos');
              navigate('/empreendedor/contratos-vendidos');
            }}
          >
            Ver tudo
          </Text>
          <FiChevronRight color="#1F7D75" size={14} />
        </VStack>
      </Flex>

      {!atividade || atividade.length === 0 ? (
        <Text color="#9AA5B1" fontSize="13px" textAlign="center" w="100%" py="8px">
          Nenhuma atividade recente.
        </Text>
      ) : (
        <Box bg="white" borderRadius="18px" border="1px solid #EEF1F5" w="100%" overflow="hidden" p="6px">
          {atividade.slice(0, 5).map((item, i) => {
            const pago = item.pago === true || item.pago === 'true';
            const partes = item.cliente ? item.cliente.split(' ') : [];
            const nomeAbrev = partes.length > 1 ? `${partes[0]} ${partes[1][0]}.` : partes[0] || '—';
            const valor = item.valor != null ? `+R$ ${Number(item.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '';
            const quando = timeAgo(item.data_cadastro);

            return (
              <React.Fragment key={i}>
                {i > 0 && <Box h="1px" bg="#EEF1F5" mx="10px" />}
                <Flex alignItems="center" gap="12px" px="10px" py="12px">
                  {/* Ícone */}
                  <Flex
                    bg={pago ? '#DCFCE7' : '#EFF6FF'}
                    borderRadius="12px"
                    w="40px"
                    h="40px"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                  >
                    {pago ? <FiCheck color="#16A34A" size={18} /> : <FiUserPlus color="#3B82F6" size={18} />}
                  </Flex>

                  {/* Texto */}
                  <VStack spacing="2px" alignItems="flex-start" flex={1} minW={0}>
                    <Text color="#0F1B2A" fontSize="13px" fontWeight="600" noOfLines={1}>
                      {pago ? 'Novo contrato confirmado' : 'Indicação recebida'}
                    </Text>
                    <Text color="#5B6B7A" fontSize="11px" fontWeight="500" noOfLines={1}>
                      {nomeAbrev} • {item.plano || 'Plano'}
                    </Text>
                  </VStack>

                  {/* Valor ou badge */}
                  <VStack spacing="2px" alignItems="flex-end" flexShrink={0}>
                    {pago ? (
                      <Text color="#16A34A" fontSize="13px" fontWeight="700">
                        {valor}
                      </Text>
                    ) : (
                      <Box bg="#FFF7ED" borderRadius="8px" px="8px" py="3px">
                        <Text color="#F97316" fontSize="10px" fontWeight="600">
                          Pendente
                        </Text>
                      </Box>
                    )}
                    <Text color="#9AA5B1" fontSize="10px" fontWeight="500">
                      {quando}
                    </Text>
                  </VStack>
                </Flex>
              </React.Fragment>
            );
          })}
        </Box>
      )}
    </VStack>
  );
}

/* ─── Main ─── */

function Main() {
  const {
    notify,
    user,
    loading,
    salesTicket,
    atividade,
    recebedor,
    handlerOnPressGerarQrCode,
    openChatSuporteWhatsapp,
    handlePreencherDadosBancarios,
    navigate,
  } = useViewModel();

  if (user.empreendedor === false) return <ModalEmpreendedor />;

  const LoadingScreen = (
    <>
      <ChildHeader />
      <Loading />
      <BottomNavBar name="empreendedor" />
    </>
  );

  if (loading) return LoadingScreen;

  if (recebedor.isRecebedorRecemCadastrado) {
    return (
      <>
        <ModalAvisoCadastroDadosBancarios
          headingTitle="Cadastro de conta bancária"
          bodyText="Realize o cadastro da sua conta bancária para começar a ser um revendor."
          icon={<GoAlertFill color="orange" size={60} style={{ marginTop: '1em' }} />}
          isOpen
          buttonText="Cadastrar conta bancária"
          onButtonPress={handlePreencherDadosBancarios}
        />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isPedidoDeAfiliacaoEmAnalise) {
    return (
      <>
        <ModalAvisoCadastroDadosBancarios
          headingTitle="Cadastro de conta bancária em análise"
          bodyText="Aguarde a análise de risco dos seus dados bancários."
          icon={<GoClock color="orange" size={60} style={{ marginTop: '1em' }} />}
          isOpen
        />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isRecebedorRejeitadoNaAnaliseDeRisco) {
    return (
      <>
        <ModalAvisoCadastroDadosBancarios
          headingTitle="Cadastro de conta bancária recusado"
          bodyText="Seu cadastro de conta bancária foi recusado, contate o suporte."
          icon={<GoAlertFill color="orange" size={60} style={{ marginTop: '1em' }} />}
          isOpen
          buttonText="Falar com o suporte"
          onButtonPress={() =>
            openChatSuporteWhatsapp(
              'Olá, estou com dificuldades para cadastrar minha conta bancária, fui rejeitado na Analise de Risco. Pode me ajudar?',
            )
          }
        />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isRecebedorPrecisaFazerProvaDeVida) {
    return (
      <>
        <Loading />
        <ModalProvaDeVida />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isProvaDeVidaRespondidaAguardandoAnalise) {
    return (
      <>
        <ModalAvisoCadastroDadosBancarios
          headingTitle="Prova de vida em análise"
          bodyText="Aguarde a análise da sua prova de vida."
          icon={<GoClock color="orange" size={60} style={{ marginTop: '1em' }} />}
          isOpen
        />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isPedidoDeAfiliacaoEmAnaliseManualDeRisco) {
    return (
      <>
        <ModalAvisoCadastroDadosBancarios
          headingTitle="Cadastro de conta bancária em análise"
          bodyText="Aguarde a análise de risco dos seus dados bancários."
          icon={<GoClock color="orange" size={60} style={{ marginTop: '1em' }} />}
          isOpen
        />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isRecebedorReprovadoNaProvaDeVida) {
    return (
      <>
        <ModalAvisoCadastroDadosBancarios
          headingTitle="Prova de vida recusada"
          bodyText="Sua prova de vida foi recusada, contate o suporte."
          icon={<GoAlertFill color="orange" size={60} style={{ marginTop: '1em' }} />}
          isOpen
          buttonText="Falar com o suporte"
          onButtonPress={() =>
            openChatSuporteWhatsapp(
              'Olá, estou com dificuldades para cadastrar minha conta bancária, fui rejeitado na Analise da Prova de Vida. Pode me ajudar?',
            )
          }
        />
        <BottomNavBar name="empreendedor" />
      </>
    );
  }

  if (recebedor.isRecebedorAprovadoNaProvaDeVida) {
    notify.success('Dados do empreendedor', 'Dados carregados com sucesso!');
  }

  return (
    <Box bg="#F4F7F9" minH="100vh" display="flex" flexDirection="column">
      <ChildHeader />

      <Box overflowY="auto" flex={1} pb="90px">
        <VStack spacing="22px" px="20px" pt="20px" pb="24px" w="100%">
          <BalanceCard salesTicket={salesTicket} navigate={navigate} />
          <KpiRow salesTicket={salesTicket} />
          <QuickActions onPressGerarQrCode={handlerOnPressGerarQrCode} navigate={navigate} />
          <AtividadeRecente atividade={atividade} />
        </VStack>
      </Box>

      <BottomNavBar name="empreendedor" />
    </Box>
  );
}

export default Main;
